export default class BaseError extends Error {
  constructor (message, title = '') {
    super(message)
    this.title = title
    this.name = 'BaseError'
  }
}
